import { render, staticRenderFns } from "./table-views-menu.vue?vue&type=template&id=66cdf521&scoped=true&"
import script from "./table-views-menu.vue?vue&type=script&lang=js&"
export * from "./table-views-menu.vue?vue&type=script&lang=js&"
import style0 from "./table-views-menu.vue?vue&type=style&index=0&id=66cdf521&prod&lang=scss&scoped=true&"
import style1 from "./table-views-menu.vue?vue&type=style&index=1&id=66cdf521&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cdf521",
  null
  
)

export default component.exports